export function summaryLine(createdCount, runCancelled, texts) {
    if (runCancelled) {
        return createdCount === 1 ? texts.modalCancelledHeadlineOne() : texts.modalCancelledHeadline({
            created: createdCount
        });
    }
    return createdCount === 1 ? texts.modalSummaryReadyOne() : texts.modalSummaryReady({
        created: createdCount
    });
}
export function unreachedClientsLine(results, texts) {
    const count = results.cancelled.length;
    return count === 1 ? texts.modalCancelledDetailOne() : texts.modalCancelledDetail({
        count
    });
}
export function failedHeadline(failed, texts) {
    return failed === 1 ? texts.modalFailedHeadlineOne() : texts.modalFailedHeadline({
        failed
    });
}
const isIdentifiable = (client)=>client.clientName.trim() !== '' || client.mainSignatoryName.trim() !== '';
export const identifiableFailures = (results)=>results.failed.filter(isIdentifiable);
export function failedRowDetail(client, texts) {
    if (client.mainSignatoryName.trim() === '') return '';
    return texts.modalFailedRow({
        signatory: client.mainSignatoryName,
        email: client.mainSignatoryEmail
    });
}
export const sendAllLabel = (count, texts)=>count === 1 ? texts.modalSendAllOne() : texts.modalSendAll({
        count
    });
